console.log('[Coaching Extension] Script loaded');

document.addEventListener('DOMContentLoaded', function() {
  // Find all pro pack upsell containers (inline and tablet versions)
  const containers = document.querySelectorAll('.pro-pack-upsell-inline, .pro-pack-upsell-tablet');
  
  if (containers.length === 0) return;
  
  let isProcessing = false;
  let shouldAddCoaching = false;
  let coachingVariantId = null;
  
  // Get the main product form
  const productForm = document.querySelector('product-form button[type="submit"]');
  
  console.log('[Coaching Extension] Found button:', productForm);
  
  // Set up event listeners for each checkbox version
  containers.forEach(container => {
    const checkbox = container.querySelector('.pro-pack-checkbox-hidden');
    const statusText = container.querySelector('.upsell-status');
    const variantId = container.dataset.variantId;
    
    if (!checkbox || !statusText || !variantId) return;
    
    coachingVariantId = variantId; // Store for later use
    
    // Just track the checkbox state - don't add to cart yet
    checkbox.addEventListener('change', function() {
      shouldAddCoaching = this.checked;
      
      // Sync all checkboxes
      containers.forEach(c => {
        const cb = c.querySelector('.pro-pack-checkbox-hidden');
        if (cb) cb.checked = this.checked;
      });
      
      // Clear status
      containers.forEach(c => {
        const st = c.querySelector('.upsell-status');
        if (st) st.textContent = '';
      });
    });
  });
  
  // Intercept the main "Add to Cart" button
  if (productForm) {
    productForm.addEventListener('click', function(e) {
      console.log('[Coaching Extension] Button clicked');
      
      if (shouldAddCoaching && !isProcessing) {
        console.log('[Coaching Extension] Will add coaching after kit is added');
        
        // Let the kit form submit normally (Simple Bundles will handle it)
        // Then add coaching extension after a brief delay
        setTimeout(function() {
          console.log('[Coaching Extension] Adding coaching extension now');
          isProcessing = true;
          
          // Update status on all versions
          containers.forEach(container => {
            const statusText = container.querySelector('.upsell-status');
            if (statusText) statusText.textContent = 'Adding extension...';
          });
          
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: coachingVariantId,
              quantity: 1,
              properties: {
                '_bundle_addon': 'true',
                '_parent_product': 'Coaching Extension',
                '_added_from': document.querySelector('.product__title h1')?.textContent || 'Product Page'
              }
            })
          })
          .then(response => response.json())
          .then(data => {
            console.log('[Coaching Extension] Successfully added:', data);
            
            // Update status on all versions
            containers.forEach(container => {
              const statusText = container.querySelector('.upsell-status');
              if (statusText) statusText.textContent = '✓ Added';
            });
            
            setTimeout(() => {
              containers.forEach(container => {
                const statusText = container.querySelector('.upsell-status');
                if (statusText) statusText.textContent = '';
              });
            }, 2000);
            
            isProcessing = false;
          })
          .catch(error => {
            console.error('[Coaching Extension] Error adding:', error);
            
            containers.forEach(container => {
              const statusText = container.querySelector('.upsell-status');
              if (statusText) statusText.textContent = 'Failed to add extension';
              const checkbox = container.querySelector('.pro-pack-checkbox-hidden');
              if (checkbox) checkbox.checked = false;
            });
            
            setTimeout(() => {
              containers.forEach(container => {
                const statusText = container.querySelector('.upsell-status');
                if (statusText) statusText.textContent = '';
              });
            }, 3000);
            
            isProcessing = false;
            shouldAddCoaching = false;
          });
        }, 1500); // Wait 1.5 seconds for the kit to be added first
      }
    });
  }
  
  console.log('[Coaching Extension] Setup complete');
});
